module.exports = __webpack_public_path__ + "media/חצוצרה.819aaef9.mp3";